module.exports = __webpack_public_path__ + "img/cover.ccb8cc10.jpg";